"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthBox = exports.useAuthBoxContext = exports.AuthBoxState = void 0;
const react_1 = __importStar(require("react"));
const AWSAuthContext_1 = require("../AWSAuthContext");
const AuthBoxResetPassword_1 = __importDefault(require("./AuthBoxResetPassword"));
const AuthBoxSendPasswordResetCode_1 = __importDefault(require("./AuthBoxSendPasswordResetCode"));
const AuthBoxSignIn_1 = __importDefault(require("./AuthBoxSignIn"));
const AuthBoxSignUp_1 = __importDefault(require("./AuthBoxSignUp"));
const AuthBoxVerifyEmail_1 = __importDefault(require("./AuthBoxVerifyEmail"));
var AuthBoxState;
(function (AuthBoxState) {
    AuthBoxState["SIGN_IN"] = "sign-in";
    AuthBoxState["SIGN_UP"] = "sign-up";
    AuthBoxState["VERIFY_EMAIL"] = "verify-email";
    AuthBoxState["SEND_PASSWORD_RESET_CODE"] = "send-password-reset-code";
    AuthBoxState["RESET_PASSWORD"] = "reset-password";
    AuthBoxState["RESET_PASSWORD_REQUIRED"] = "reset-password-required";
})(AuthBoxState = exports.AuthBoxState || (exports.AuthBoxState = {}));
const Context = react_1.default.createContext({});
function useAuthBoxContext() {
    return (0, react_1.useContext)(Context);
}
exports.useAuthBoxContext = useAuthBoxContext;
function AuthBox({ authBoxState = AuthBoxState.SIGN_IN, onAuthBoxStateChange, email = "", termsAndConditionsUrl, userNotFoundExplanation, onAuthenticated = () => { }, presetVerificationCode, noHeader = false, }) {
    const { state: appAuthState } = (0, AWSAuthContext_1.useAuthContext)();
    /*
    const [authBoxState, setAuthBoxState] = useState<AuthBoxState>(
      initialAuthState
    );
    */
    function setAuthBoxState(state) {
        onAuthBoxStateChange(state);
    }
    const [authenticationDetails, setAuthenticationDetails] = (0, react_1.useState)({
        email,
        password: "",
    });
    // Once we sign in the auth box should inform the parent that we're all done.
    (0, react_1.useEffect)(() => {
        if (appAuthState === AWSAuthContext_1.AuthState.Authenticated) {
            onAuthenticated();
        }
    }, [appAuthState]);
    // Once we sign in the auth box should inform the parent that we're all done.
    (0, react_1.useEffect)(() => {
        if (appAuthState === AWSAuthContext_1.AuthState.Authenticated) {
            onAuthenticated();
        }
    }, [appAuthState]);
    if (appAuthState === AWSAuthContext_1.AuthState.Initializing ||
        appAuthState === AWSAuthContext_1.AuthState.Authenticated) {
        return null;
    }
    // Called when we have completed authenticating
    function complete() {
        onAuthenticated();
    }
    return (react_1.default.createElement(Context.Provider, { value: {
            termsAndConditionsUrl,
            userNotFoundExplanation,
            authenticationDetails,
            authBoxState,
            presetVerificationCode,
            noHeader,
            setAuthBoxState,
            setAuthenticationDetails,
            complete,
        } },
        react_1.default.createElement(AuthBoxWithContext, null)));
}
exports.AuthBox = AuthBox;
function AuthBoxWithContext() {
    const { authBoxState, authenticationDetails } = useAuthBoxContext();
    switch (authBoxState) {
        case AuthBoxState.SIGN_IN:
            return react_1.default.createElement(AuthBoxSignIn_1.default, { key: AuthBoxState.SIGN_IN });
        case AuthBoxState.SIGN_UP:
            return react_1.default.createElement(AuthBoxSignUp_1.default, { key: AuthBoxState.SIGN_UP });
        case AuthBoxState.VERIFY_EMAIL:
            return react_1.default.createElement(AuthBoxVerifyEmail_1.default, { key: AuthBoxState.VERIFY_EMAIL });
        case AuthBoxState.SEND_PASSWORD_RESET_CODE:
            return (react_1.default.createElement(AuthBoxSendPasswordResetCode_1.default, { key: AuthBoxState.SEND_PASSWORD_RESET_CODE }));
        case AuthBoxState.RESET_PASSWORD:
            return react_1.default.createElement(AuthBoxResetPassword_1.default, { key: AuthBoxState.RESET_PASSWORD });
        case AuthBoxState.RESET_PASSWORD_REQUIRED:
            return (react_1.default.createElement(AuthBoxResetPassword_1.default, { key: AuthBoxState.RESET_PASSWORD_REQUIRED },
                react_1.default.createElement("p", null,
                    "You must reset your password before logging in. An email has been sent to ",
                    react_1.default.createElement("strong", null, authenticationDetails.email),
                    " with a verification code.")));
    }
}
//# sourceMappingURL=data:application/json;base64,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